var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'transparent-loader': _vm.fullScreen === true, 'loader--full-parent': _vm.fullParent }},[_c('div',{staticClass:"loader",class:{ 'loader--sm': _vm.size === 'small' }})])}
var staticRenderFns = []

export { render, staticRenderFns }